import React from 'react';
import { center, loader } from './Loader.module.css';

const Loader = () => <div className={center}><div className={loader}><div /><div /></div></div>

export default Loader